/**
 * グローバルヘッダー（告知〜メインヘッダー・SPメニュー）
 */
export function initHeader() {
  const burger = document.querySelector('#js-hamburger');
  const nav = document.querySelector('#js-nav');
  const body = document.body;
  const stickyTop = document.querySelector('#js-sp-sticky-top');
  const bottomCta = document.querySelector('#js-sp-bottom-cta');
  const root = document.documentElement;

  if (!burger || !nav) return;

  const updateSpMenuInset = () => {
    if (!stickyTop || !bottomCta || window.matchMedia('(min-width: 900px)').matches) {
      root.style.removeProperty('--fortune-sp-nav-top');
      root.style.removeProperty('--fortune-sp-nav-bottom');
      return;
    }
    root.style.setProperty('--fortune-sp-nav-top', `${stickyTop.offsetHeight}px`);
    root.style.setProperty('--fortune-sp-nav-bottom', `${bottomCta.offsetHeight}px`);
  };

  updateSpMenuInset();
  window.addEventListener('resize', updateSpMenuInset);
  if (typeof ResizeObserver !== 'undefined' && stickyTop && bottomCta) {
    const ro = new ResizeObserver(updateSpMenuInset);
    ro.observe(stickyTop);
    ro.observe(bottomCta);
  }

  const setOpen = (open) => {
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    burger.setAttribute('aria-label', open ? 'メニューを閉じる' : 'メニューを開く');
    nav.setAttribute('aria-hidden', open ? 'false' : 'true');
    body.classList.toggle('is-nav-open', open);
    body.style.overflow = open ? 'hidden' : '';

    updateSpMenuInset();

    nav.classList.toggle('translate-x-full', !open);
    nav.classList.toggle('translate-x-0', open);
    nav.classList.toggle('pointer-events-none', !open);
    nav.classList.toggle('pointer-events-auto', open);
  };

  burger.addEventListener('click', () => {
    const isOpen = burger.getAttribute('aria-expanded') === 'true';
    setOpen(!isOpen);
  });

  nav.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', () => {
      setOpen(false);
    });
  });

  if (bottomCta) {
    bottomCta.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => {
        setOpen(false);
      });
    });
  }

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && burger.getAttribute('aria-expanded') === 'true') {
      setOpen(false);
      burger.focus();
    }
  });
}
